// extracted by mini-css-extract-plugin
module.exports = {"MenuIcon":"MenuIcon_MenuIcon__8kJuS","Bar1":"MenuIcon_Bar1__3zcQk","Bar2":"MenuIcon_Bar2__2M_Si","Bar3":"MenuIcon_Bar3__1RrmB","Change":"MenuIcon_Change__1LIL2"};